var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5996C14.6745 13.5996 13.6 14.6741 13.6 15.9996V18.3996C13.6 19.7251 14.6745 20.7996 16 20.7996H18.4C19.7255 20.7996 20.8 19.7251 20.8 18.3996V15.9996C20.8 14.6741 19.7255 13.5996 18.4 13.5996H16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.1996C14.6745 23.1996 13.6 24.2741 13.6 25.5996V27.9996C13.6 29.3251 14.6745 30.3996 16 30.3996H18.4C19.7255 30.3996 20.8 29.3251 20.8 27.9996V25.5996C20.8 24.2741 19.7255 23.1996 18.4 23.1996H16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 15.9996C23.2 14.6741 24.2745 13.5996 25.6 13.5996H28C29.3255 13.5996 30.4 14.6741 30.4 15.9996V18.3996C30.4 19.7251 29.3255 20.7996 28 20.7996H25.6C24.2745 20.7996 23.2 19.7251 23.2 18.3996V15.9996Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 25.5996C23.2 24.2741 24.2745 23.1996 25.6 23.1996H28C29.3255 23.1996 30.4 24.2741 30.4 25.5996V27.9996C30.4 29.3251 29.3255 30.3996 28 30.3996H25.6C24.2745 30.3996 23.2 29.3251 23.2 27.9996V25.5996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.8f2b9b488e946222970d7794b0741b6a.svg";
export { ForwardRef as ReactComponent };